import * as React from 'react';
const SvgHeart = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="#fff" fillOpacity={0.01} d="M0 0h24v24H0z" />
    <path
      fill="currentColor"
      d="M15.113 7c.4 0 .79.07 1.14.21q.527.21.919.6c.26.26.46.57.61.92.15.36.22.76.22 1.21 0 .74-.22 1.5-.66 2.25-.47.81-1.16 1.62-2.05 2.41-.918.81-2.018 1.61-3.267 2.34 0 0-.01 0-.02.01-1.27-.75-2.379-1.54-3.288-2.36-.89-.79-1.579-1.6-2.049-2.41-.44-.75-.66-1.51-.66-2.25 0-.44.08-.85.22-1.21.15-.35.35-.66.61-.92s.57-.46.92-.6c.34-.14.73-.21 1.129-.21.51 0 .98.12 1.32.33.149.1.299.21.429.33l1.369 1.27 1.36-1.27c.13-.12.269-.23.419-.32.35-.21.82-.33 1.32-.33m.01-2c-.85 0-1.69.21-2.38.63-.26.16-.51.35-.729.56-.22-.21-.46-.39-.72-.56-.69-.42-1.539-.63-2.388-.63-.65 0-1.3.12-1.879.36-.6.24-1.13.59-1.579 1.03-.45.45-.81.98-1.06 1.58S4 9.24 4 9.95c0 1.1.31 2.2.93 3.26.58 1 1.399 1.97 2.448 2.9 1.02.9 2.229 1.77 3.608 2.58.12.07.25.13.4.19.21.08.42.12.609.12.19 0 .41-.04.62-.12.15-.06.28-.12.41-.19 1.368-.81 2.578-1.68 3.597-2.58 1.05-.93 1.869-1.9 2.449-2.9.62-1.06.929-2.16.929-3.26 0-.71-.13-1.37-.38-1.98-.25-.6-.6-1.13-1.05-1.58-.449-.45-.979-.79-1.578-1.04A5.1 5.1 0 0 0 15.113 5"
    />
  </svg>
);
export default SvgHeart;
